// extracted by mini-css-extract-plugin
export default {"baseIconLegacy":"styles-module__baseIconLegacy__b3c913bc0670e84c265b","baseIcon":"styles-module__baseIcon__c04e3087d8090f93ffe3"};